'use strict';

var request = require('./request');

var PATH = 'authentication';

var AuthenticationApi = {

  login: function login(email, password) {
    return request.post(PATH, { email: email, password: password });
  },

  load: function load() {
    return request.get(PATH);
  }

};

module.exports = AuthenticationApi;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/api/authentication.js
 **/